export default {
    "welcomeMessage": "Use filters to show <0>{{nameCollection}}</0>.",
    "noDataMessage": "There is no <0>{{nameCollection}}</0> to show according to the filters applied."
}